import React from "react";

import AppModal from "../../components/AppModal";
import { i18n } from "../../translate/i18n";

function ExportingModal({
	open,
	onClose,
	onConfirm,
	exportingLoading,
	exportCount,
}) {
	const handleClose = () => {
		if (exportingLoading) return;
		onClose();
		onConfirm?.();
	};

	const title = exportingLoading
		? i18n.t("contactsExportModal.titleExporting")
		: i18n.t("contactsExportModal.titleDone");

	return (
		<AppModal
			open={open}
			onClose={handleClose}
			title={title}
			maxWidth={480}
			footer={
				<button
					type="button"
					className="btn btn-primary"
					onClick={handleClose}
					disabled={exportingLoading}
				>
					{i18n.t("contactsExportModal.close")}
				</button>
			}
		>
			{exportingLoading ? (
				<div className="app-modal-loading">
					<div className="app-modal-spinner" />
					<p className="m-0 text-sm text-default-500 dark:text-default-400">
						{i18n.t("contactsExportModal.exporting")}
					</p>
				</div>
			) : (
				<p className="m-0 text-sm text-default-700 dark:text-default-200">
					{i18n.t("contactsExportModal.done", { count: exportCount ?? 0 })}
				</p>
			)}
		</AppModal>
	);
}

export default ExportingModal;
